import _objectWithoutProperties from "/home/denis/workspace/smartheat/pump-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
import { angleData } from "./angleData";
import { normalizeAngle, getClockPos } from "./utils";
export function ClockPoint(_ref) {
  var Component = _ref.as,
      angle = _ref.angle,
      clockRadius = _ref.clockRadius,
      onMove = _ref.onMove,
      restProps = _objectWithoutProperties(_ref, ["as", "angle", "clockRadius", "onMove"]);

  var normalizedAngle = normalizeAngle(angle);
  var data = angleData[normalizedAngle];

  var dragBoundFunc = function dragBoundFunc(data) {
    var clockPos = getClockPos(data.localPos);
    var delta = clockRadius - clockPos.distance;

    if (onMove) {
      return onMove(clockPos, delta, data);
    }
  };

  return /*#__PURE__*/React.createElement(Component, Object.assign({
    angle: normalizedAngle,
    x: data.cos * clockRadius,
    y: data.sin * clockRadius,
    dragBoundFunc: dragBoundFunc
  }, restProps));
}